<template>
    <section>
        <h4 v-if="mostrarTitulo" style="font-weight: 800; padding-bottom: 6px">
            {{ $t('mensagens.territorio.territorioAr.titulo') }}
        </h4>

        <el-card>
            <el-form
                :model="form"
                :rules="rules"
                ref="fields"
                label-position="top"
            >
                <h4 style="font-weight: 600; color: #3b3b3b; margin-top: 15px">
                    {{ $t('mensagens.territorio.territorioAr.datos') }}
                </h4>
                <div class="columns" :gutter="20">
                    <el-form-item
                        prop="nome"
                        key="form.nome"
                        :label="$t('mensagens.territorio.territorioAr.fazenda')"
                    >
                        <el-input
                            v-model="form.nome"
                            :placeholder="
                                $t('mensagens.territorio.territorioAr.fazenda')
                            "
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        v-if="isSucursal"
                        :label="
                            $t(
                                'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.sucursal'
                            )
                        "
                        prop="sucursal"
                    >
                        <el-select
                            v-model="form.sucursal"
                            :placeholder="$t('mensagens.comuns.selecione')"
                            clearable
                            filterable
                        >
                            <el-option
                                v-for="sucursal in sucursais"
                                :key="sucursal.id"
                                :label="sucursal.label"
                                :value="sucursal.id"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item
                        prop="provincia"
                        :label="$t('mensagens.territorio.labels.provincia')"
                    >
                        <el-input
                            disabled
                            v-model="form.provincia"
                            :placeholder="
                                $t('mensagens.territorio.labels.provincia')
                            "
                            style="width: 100%"
                        />
                    </el-form-item>
                    <el-form-item
                        prop="renspa"
                        :label="$t('mensagens.territorio.labels.renspa')"
                    >
                        <input
                            type="hidden"
                            v-model="form.renspa"
                            v-mask="'##.###.#.#####/##'"
                        />
                        <el-input
                            v-model="form.renspa"
                            :placeholder="
                                $t('mensagens.territorio.labels.renspa')
                            "
                            style="width: 100%"
                            v-mask="'##.###.#.#####/##'"
                            @input="buscarProvincia"
                        />
                    </el-form-item>
                    <el-form-item
                        prop="verificadoAr"
                        :label="$t('mensagens.territorio.labels.verificadoAr')"
                    >
                        <el-input
                            disabled
                            v-model="form.verificadoAr"
                            :placeholder="
                                $t('mensagens.territorio.labels.verificadoAr')
                            "
                            style="width: 100%"
                        />
                    </el-form-item>
                    <el-form-item
                        prop="codigoOncca"
                        :label="$t('mensagens.territorio.labels.codigoOncca')"
                    >
                        <el-input
                            disabled
                            v-model="form.codigoOncca"
                            :placeholder="
                                $t('mensagens.territorio.labels.codigoOncca')
                            "
                            style="width: 100%"
                        />
                    </el-form-item>
                    <el-form-item
                        prop="idInterno"
                        :label="$t('mensagens.territorio.labels.idInterno')"
                    >
                        <el-input
                            v-model="form.idInterno"
                            :placeholder="
                                $t('mensagens.territorio.labels.idInterno')
                            "
                            maxlength="50"
                            show-word-limit
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        prop="codigoLyra"
                        :label="$t('mensagens.territorio.labels.codigoLyra')"
                    >
                        <el-input
                            disabled
                            v-model="form.codigoLyra"
                            :placeholder="
                                $t('mensagens.territorio.labels.codigoLyra')
                            "
                            style="width: 100%"
                        />
                    </el-form-item>
                </div>
                <informacao-agricula
                    @update="addInformation"
                    :options="form.informacoesAgricolas"
                    :cultivos="cultivo"
                    @delete="deleteInformation"
                />
            </el-form>
        </el-card>
    </section>
</template>
<script>
import SucursaleService from '@/services/SucursaleService';
import InformacaoAgricula from './InformacaoAgriculaAr.vue';
import TerritorioService from '@/services/TerritorioService';

export default {
    props: {
        optionsRespa: {
            type: Array,
            default: () => []
        },
        optionsProvincia: {
            type: Array,
            default: () => []
        },
        cultivo: {
            type: Array,
            default: () => []
        },
        fields: {
            type: Object,
            default: () => {}
        },
        isSucursal: {
            type: Boolean,
            default: false
        },
        mostrarTitulo: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            form: {
                nome: '',
                sucursal: '',
                provincia: '',
                renspa: '',
                informacoesAgricolas: [],
                idInterno: '',
                verificadoAr: '',
                codigoOncca: '',
                codigoLyra: ''
            },
            sucursais: [],
            prevRenspa: '',

            rules: {
                nome: [
                    {
                        required: true,
                        message: this.$t(
                            'mensagens.territorio.preenchaCampoObrigatorio'
                        ),
                        trigger: ['blur', 'change']
                    }
                ],
                sucursal: [
                    {
                        required: true,
                        message: this.$t(
                            'mensagens.territorio.preenchaCampoObrigatorio'
                        ),
                        trigger: ['blur', 'change']
                    }
                ],
                provincia: [
                    {
                        required: false
                    }
                ],
                renspa: [
                    {
                        required: false
                    },
                    {
                        validator: (rule, value, callback) =>
                        this.validarRenspaMascara(rule, value, callback),
                        trigger: ['blur', 'change']
                    }
                ],

                codigoOncca: [
                    {
                        required: false
                    }
                ],
                idInterno: [
                    {
                        max: 50,
                        message: this.$t(
                            'mensagens.territorio.idInternoMaximoCaracteres'
                        ),
                        trigger: ['blur', 'change']
                    }
                ],
                verificadoAr: [
                    {
                        required: false
                    }
                ]
            }
        };
    },
    components: {
        InformacaoAgricula
    },

    watch: {
        form: {
            handler: function (value) {
                this.$refs['fields'].validate(async valid => {
                    if (valid && value.informacoesAgricolas.length > 0) {
                        this.$emit('update', value);
                        this.$emit('validate', true);
                    } else {
                        this.$emit('validate', false);
                    }
                });
            },
            deep: true
        },
        'form.sucursal'(value) {
            this.$emit('sucursal', value);
        },
        fields: {
            handler(value) {
                if (!value || Object.keys(value).length === 0) return;
                this.$nextTick(() => {
                    this.form.nome = value.nome;
                    this.form.sucursal = value.sucursal;
                    this.form.provincia = value.provincia;
                    this.form.renspa = value.renspa;
                    this.form.informacoesAgricolas =
                        value.informacoesAgricolas || [];
                    this.form.idInterno = value.idInterno || '';
                    this.form.verificadoAr = value.verificadoAr;
                    this.form.codigoOncca = value.codigoOncca;
                    this.form.codigoLyra = value.codigoLyra;
                });
            },
            deep: true
        }
    },
    created() {
        if (this.isSucursal) {
            this.listarSucursais();
        }
    },
    methods: {
        addInformation(value) {
            this.form.informacoesAgricolas.push(value);
        },
        deleteInformation(index) {
            this.form.informacoesAgricolas.splice(index, 1);
        },
        async listarSucursais() {
            try {
                const { data } = await SucursaleService.listagem();
                const dataFormat = data.sucursais
                    .map(item => {
                        return { label: item.nome, id: item.id };
                    })
                    .sort((a, b) => this.orderName(a, b));
                this.sucursais = dataFormat;
            } catch (error) {
                this.$notify.error({
                    message: this.$t('mensagens.sistema.erroInformacoes')
                });
            }
        },
        orderName(a, b) {
            const nameA = a.label.toUpperCase();
            const nameB = b.label.toUpperCase();
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }
            return 0;
        },
        async buscarProvincia() {
            if (this.form.renspa.length < 2) {
                this.form.provincia = '';
                this.prevRenspa = '';
                return;
            }
            const codigoExtraido = this.form.renspa.slice(0, 2);

            if (codigoExtraido === this.prevRenspa) {
                // Se não mudou, não faz a requisição
                return;
            }

            this.prevRenspa = codigoExtraido;

            try {
                const { data } =
                    await TerritorioService.obterProvinciaPorCodigoArgentina(
                        codigoExtraido
                    );
                this.form.provincia = data;
            } catch (error) {
                this.form.provincia = '';
                this.prevRenspa = '';

                if (error?.response?.status === 404) {
                    this.$notify.error({
                        message: this.$t(
                            'mensagens.territorio.erroMensagem.provinciaNaoEncontrada'
                        )
                    });
                }
            }
        },
        validarRenspaMascara(rule, value, callback) {
            // deixa o required cuidar do vazio
            if (!value) return callback();
            const digits = value.toString().replace(/\D/g, '');

            // precisa ter exatamente 13 números
            if (digits.length < 13) {
                return callback(new Error('Renspa incompleto, precisa ter 13 caracteres'));
            }
            return callback();
        }
    }
};
</script>

<style scoped lang="scss">
.columns {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1rem;

    div,
    select,
    input {
        width: 100%;
    }
}
</style>
